import { LeadType, LeadTypeString } from '@nttp/enum/lead-type.enum';
import { environment } from '@pg-env/environment';

export class AccountTypeHelper {
    public static getLeadType(name: string) {
        if(environment.isPrivalgoMarkets) {
          if (name === LeadTypeString.MarketsCorporate)
            return LeadType.MarketsCorporate;
          if (name === LeadTypeString.MarketsInstitution)
            return LeadType.MarketsInstitution;
          if (name === LeadTypeString.MarketsPartner)
            return LeadType.MarketsPartner;
        }
        else {
          if (name === LeadTypeString.Corporate)
              return LeadType.Corporate;
          if (name === LeadTypeString.Contact)
              return LeadType.Contact;
          if (name === LeadTypeString.Affiliate)
              return LeadType.Affiliate;
          if (name === LeadTypeString.Private)
              return LeadType.Private;
        }
        return null;
    }
  }
